<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>



<div class="container d-flex justify-content-center align-items-center vh-100">
    <div class="main-content col-lg-2">
        <div class="custom-card mx-auto" style="width: 25rem; align-items: center;">
            <div class="card-body">
                <!-- Login Fields -->
                <div class="collapse mt-1 show" id="loginFields">
                    <form [formGroup]="loginForm">
                        <img src="./assets/ghs.png" alt="Logo"  class="img-fluid mb-2 mb-lg-0" style="width: 60px; height: 60px;" >
                        <h4 class="custom-card-title">Please sign in</h4>
                        <p class="textField">Please use &#64;gcpsk12.org account</p>

                        <div *ngIf="incorrectLogin" class="alert alert-danger">
                            Your credentials are incorrect. Please try again.
                        </div>
                        <div class="form-floating mb-1">
                            <input type="email" class="form-control" id="floatingInput" placeholder="name@gcpsk12.com" formControlName="userEmail" required
                            [ngClass]="{'is-invalid': loginForm.get('userEmail')?.invalid && loginForm.get('userEmail')?.touched}"
                            >
                            <label for="floatingInput">Email address</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="password" class="form-control" id="floatingPassword" placeholder="Password" formControlName="password" required
                            [ngClass]="{'is-invalid': loginForm.get('password')?.invalid && loginForm.get('password')?.touched}"
                            >
                            <label for="floatingPassword">Password</label>
                        </div>



                        <button class="btn btn-primary w-100" type="submit" (click)="submitLogIn()">Sign in</button>
                        <br>
                        <div class="d-flex justify-content-center flex-column">
                            <button class="btn btn-link d-block mt-2" type="button" (click)="showForgotPassword()">Forgot Password</button>
                            <button class="btn btn-link d-block mt-1" type="button" (click)="showRegister()">Register</button>
                        </div>

                    </form>
                </div>

                <!-- Registration -->
                <div class="collapse mt-3" id="registerFields">
                    <div *ngIf="registerEmailSent || registerFailed;else normalRegister">
                        <h4 class="custom-card-title">{{ registerEmailSent && 'Please check your email for the register link.' || 'Something went wrong, please try again later.' }}</h4>
                        <button class="btn btn-primary w-100 mt-2" type="button" (click)="showLogin()">Go Back</button>
                    </div>

                    <ng-template #normalRegister>
                        <h4 class="custom-card-title">Please Register</h4>
                        <form [formGroup]="createForm">
                            <p class="textField">Please use &#64;gcpsk12.org account</p>
                            <div class="form-floating mb-3">
                                <input type="email" class="form-control" id="floatingRegisterEmail" placeholder="Email" formControlName="email" (input)="checkEmails()">
                                <label for="floatingRegisterEmail">Email</label>
                            </div>
                            <div class="form-floating mb-3">
                                <input type="email" class="form-control" id="floatingConfirmEmail" placeholder="Email confirmation" (input)="checkEmails()">
                                <label for="floatingConfirmEmail">Confirm Email</label>
                            </div>
                            <div class="form-check mb-3">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                id="termsCheckbox"
                            /> <!-- formControlName="acceptTerms" -->
                            <label class="form-check-label" for="termsCheckbox">
                                By registering, you agree to our
                                <a href="/" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>.
                            </label>
                            </div>
                            <button class="btn btn-primary w-100" type="submit" (click)="createAcct()" id="submitEmailbtn">Submit</button>
                            <button class="btn btn-danger w-100 mt-2" type="button" (click)="showLogin()">Cancel</button>
                        </form>
                    </ng-template>

                </div>

                <!-- Forgot Password -->
                <div class="collapse mt-3" id="forgotPassword">
                    <h4 class="custom-card-title">Forgot Password</h4>
                    <form [formGroup]="createForm">
                        <p>Please enter your email to begin account recovery process.</p>
                        <div class="form-floating mb-3">
                            <input type="email" class="form-control" id="floatingRecoveryEmail" placeholder="Email" formControlName="email">
                            <label for="floatingRecoveryEmail">Email</label>
                        </div>
                        <button class="btn btn-primary w-100" type="submit" (click)="resetPassword()">Reset Password</button>
                        <button class="btn btn-danger w-100 mt-2" type="button" (click)="showLogin()">Cancel</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
